// extracted by mini-css-extract-plugin
module.exports = {"container":"_94af1ce5"};